import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {Button, Chip, Grid, Paper, Stack, styled, Typography} from "@mui/material";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import {useParams} from "react-router-dom";


interface overallReadingsSection {
    value : string | null,
    skeleton : boolean,
    setValue : Dispatch<SetStateAction<string>>,
    setActiveLink : Dispatch<SetStateAction<string>>,
    devices : any,
    setCurrentDevice : Dispatch<SetStateAction<string>>,
}


let initialChips = [
    {
        id:1,
        lable:"Day",
        isActive:false,
    },
    {
        id:2,
        lable:"Week",
        isActive:false,
    },
    {
        id:3,
        lable:"Month",
        isActive:false,
    },
    {
        id:4,
        lable:"Year",
        isActive:true,
    }
]

export const OverallReadingsSection = ( { value, setValue, setActiveLink,skeleton,devices,setCurrentDevice } : overallReadingsSection ) =>{

    const [chips,setChips] = useState(initialChips)

    const params = useParams()

    const handleChips = (id : number) =>{
        setChips(prevState => {
           return prevState.map(c=>{
                return c.id === id ? {...c , isActive : true} : {...c,isActive : false}
            })
        })

        let activeLink = chips.filter(e=>e.id === id)[0].lable

        setActiveLink(activeLink)
    }

    const handleDevicesDropDown = (e : any) =>{
            setCurrentDevice(e)
    }

    const OnDateChange = (newValue:Date) => {
        let ISOstring = new Date(newValue!).toISOString()
        setValue(ISOstring.split('T')[0]!);
        setChips(initialChips.map(e=>{
            return e.isActive === true ? {...e,isActive:false} : e
        }))
        setActiveLink("")
    }

    useEffect(()=>{
        let devices = localStorage
    },[])

    const ActiveChip = {color:"#089BAB",background:"#FFFFFF",padding:"10px",fontSize:"20px"}

    const NonActiveChip = {color:"grey",background:"none",padding:"10px",fontSize:"20px"}

    return(
    <>
        {
            skeleton ?
                <Stack direction={"row"} justifyContent={"space-between"} marginTop={4}>
                    <Stack direction={"row"}
                           spacing={2}
                    >
                        <Skeleton variant="rectangular" width={196} height={39} />
                        <Skeleton variant="rectangular" width={229} height={40} />
                    </Stack>
                    <Stack direction={"row"} spacing={6} justifyContent="flex-end">
                        {
                            chips.map((e)=>(
                                <Skeleton key={e.id} variant="rectangular" width={77} height={32} sx={{borderRadius:"16px"}} />
                            ))
                        }
                    </Stack>
                </Stack>
                :
                <Grid
                    marginTop={2}
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}

                    flexWrap="wrap"
                >


                    <Grid container item spacing={2} md={6}>
                        <Grid item xs="auto">
                            <Typography
                                fontSize={26}
                                fontWeight={700}
                                color="#081735"
                            >
                                Overall Readings
                            </Typography>
                        </Grid>
                        <Grid item xs={"auto"}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="Custom input"
                                    value={value}
                                    maxDate={new Date()}
                                    onChange={(newValue) => {
                                        OnDateChange(newValue!)
                                    }}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <Box sx={{ display: 'flex', alignItems: 'center',background:"#FFFFFF",padding:"0px 10px",borderRadius:"12px",height:"40px"}}>
                                            <input ref={inputRef} {...inputProps} style={{border:"none"}} />
                                            {InputProps?.endAdornment}
                                        </Box>
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={"auto"}>
                            {
                                devices.length>1
                                ?
                                    <select
                                        style={{
                                            border:"none",
                                            background:"#F9FAFC",
                                            padding:"10px",
                                            borderRadius:"15px"
                                        }}
                                        // defaultValue="100000000000001"
                                        // value={"All Categories"}
                                        onChange={(e)=>{handleDevicesDropDown(e.target.value)}}
                                    >
                                        {
                                            devices.map((e:any)=>(
                                                <option
                                                    value={e.imei}
                                                    key={e.id}
                                                    selected={e.imei === params['id'] ? true : false}
                                                >{e.alias}</option>
                                            ))
                                        }
                                    </select>
                                    :''
                            }
                        </Grid>
                    </Grid>


                    <Grid container item spacing={3} md={6} justifyContent="flex-end">

                        {
                            chips.map((c)=>(
                                <Grid item xs={"auto"} key={c.id}>
                                    <Chip label={c.lable} onClick={(e)=>{handleChips(c.id)}}
                                          style = {c.isActive ? ActiveChip : NonActiveChip}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
        }
    </>
    )
}